// Simplified and reliable navigation utility

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

export const scrollToSection = (sectionId, offset = 80) => {
  console.log('🔍 scrollToSection called:', { sectionId, offset });
  
  // Try multiple times to find the element (for elements that load dynamically)
  const tryScroll = (attempts = 0) => {
    const element = document.getElementById(sectionId);
    console.log('🔍 Looking for element:', { sectionId, found: !!element, attempts });
    
    if (element) {
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;
      
      console.log('🔍 Scrolling to position:', { elementPosition, offsetPosition });
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    } else if (attempts < 10) {
      console.log('🔍 Element not found, retrying...');
      // Try again after a short delay
      setTimeout(() => tryScroll(attempts + 1), 200);
    } else {
      console.log('🔍 Element not found after 10 attempts');
    }
  };
  
  // Start the first attempt immediately, then use setTimeout for subsequent attempts
  setTimeout(() => tryScroll(), 100);
};

// Simple navigation functions
export const navigateToHome = (navigate) => {
  const currentPath = window.location.pathname;
  if (currentPath === '/') {
    scrollToTop();
  } else {
    navigate('/');
    setTimeout(scrollToTop, 100);
  }
};

export const navigateToServices = (navigate) => {
  const currentPath = window.location.pathname;
  if (currentPath === '/') {
    scrollToSection('services');
  } else if (currentPath === '/services') {
    scrollToTop();
  } else {
    navigate('/services');
    setTimeout(scrollToTop, 100);
  }
};

export const navigateToRecipes = (navigate) => {
  const currentPath = window.location.pathname;
  if (currentPath === '/') {
    scrollToSection('recipes');
  } else if (currentPath === '/recipes') {
    scrollToTop();
  } else {
    navigate('/recipes');
    setTimeout(scrollToTop, 100);
  }
};

export const navigateToTransformations = (navigate) => {
  const currentPath = window.location.pathname;
  if (currentPath === '/') {
    scrollToSection('transformations');
  } else if (currentPath === '/transformations') {
    scrollToTop();
  } else {
    navigate('/transformations');
    setTimeout(scrollToTop, 100);
  }
};

export const navigateToAbout = (navigate) => {
  navigate('/about');
  setTimeout(scrollToTop, 100);
};

export const navigateToContact = (navigate) => {
  navigate('/contact');
  setTimeout(scrollToTop, 100);
};

export const navigateToConsultation = (navigate) => {
  const currentPath = window.location.pathname;
  console.log('🔍 navigateToConsultation called:', { currentPath });
  
  if (currentPath === '/contact') {
    console.log('🔍 Already on contact page, scrolling to consultation section');
    // If already on contact page, scroll immediately
    scrollToSection('consultation', 100);
  } else {
    console.log('🔍 Navigating to contact page, then scrolling to consultation');
    // Navigate to contact page first
    navigate('/contact');
    
    // Wait for navigation and page load, then scroll
    setTimeout(() => {
      console.log('🔍 Scrolling to consultation section after navigation');
      scrollToSection('consultation', 100);
    }, 1000);
    
    // Also try scrolling after a longer delay in case the page takes time to load
    setTimeout(() => {
      console.log('🔍 Second attempt to scroll to consultation section');
      scrollToSection('consultation', 100);
    }, 2000);
  }
};

// Handle hash navigation on page load
export const handleHashNavigation = () => {
  const hash = window.location.hash.slice(1);
  if (hash) {
    console.log('🔍 Hash navigation detected:', hash);
    // Try multiple times with different delays
    setTimeout(() => scrollToSection(hash), 300);
    setTimeout(() => scrollToSection(hash), 800);
    setTimeout(() => scrollToSection(hash), 1500);
  }
};